/** @file eventName: the name an effect trigger matches (a custom event's string payload, else its type). */

/** `custom` with a string payload -> the payload; anything else -> the event type. */
export function eventName(e: { type: string; payload?: unknown }): string {
  return e.type === 'custom' && typeof e.payload === 'string' ? e.payload : e.type;
}
